// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ====== Generic flex/height helpers ====== */
.desc-col {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.desc-fill {
    flex: 1 1;
    min-height: 0;
}

.desc-no-x {
    overflow-x: hidden;
}

/* ====== Section headings ====== */
.desc-label-row {
    padding-left: 10px;
}

/* ====== Box wrapper (γκρι κάρτα) ====== */
.desc-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    /* κόβει οριζόντιο */
    padding: 10px;
}

/* ====== Inner white panel (textarea) ====== */
.desc-panel {
    flex: 1 1;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .2);
    overflow: hidden;
}

.desc-textarea {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 0;
    box-sizing: border-box;
    resize: none;
    border: none;
    outline: none;
    background: transparent;
    overflow-wrap: anywhere;
}

/* ====== Lock notice ====== */
.desc-lock {
    padding: 8px 8px;
    border-radius: 12px;
    background: #E5E7EB;
    border: 1px solid #bbb;
    color: #374151;
    display: flex;
    box-shadow: 0 4px 6px rgba(0, 0, 0, .15);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 8px;
    min-height: 60px;
    font-size: 12px;
    font-weight: 500;
}

.desc-lock-title {
    font-size: 12px;
    font-weight: 700;
    color: #111827;
}

/* ====== Buttons row (πάντα ίδια σειρά, responsive) ====== */
.desc-buttons-row {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.desc-btn-col {
    text-align: center;
    flex: 1 1;
    min-width: 140px;
}

.desc-btn-full {
    width: 100%;
}

/* ====== Skills (read-only) panel ====== */
.skills-wrapper {
    height: 100%;
    min-height: 0;
}

.skills-box {
    position: relative;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    padding: 10px;
}

.skills-scroll {
    height: calc(100% - 48px);
    /* αφήνει χώρο για το input */
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

/* Ρίζα: γεμίζει το διαθέσιμο ύψος και επιτρέπει στα παιδιά να κάνουν σωστό scroll */
.desc-root {
    height: 100%;
    min-height: 0;
}

/* Το βασικό Col: να μπορεί να “σπάει” σωστά και να τεντώνει */
.desc-col {
    min-width: 0;
    height: 100%;
}

/* Πάνω σειρά με το label */
.desc-label-row {
    padding-left: 10px;
}

/* Η σειρά που περιέχει το boxStyle: υπολογισμένο ύψος και μηδενικό min-height για σωστό overflow */
.desc-content-row {
    height: calc(100% - 28px);
    min-height: 0;
}

/* Το Col που περιέχει το boxStyle: γεμίζει, δεν επιβάλλει δικό του overflow */
.desc-content-col {
    height: 100%;
    min-height: 0;
}`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/Description/description.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;AACtB;;AAEA,2CAA2C;AAC3C;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;AACjB;;AAEA,+CAA+C;AAC/C;IACI,SAAO;IACP,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,wCAAwC;IACxC,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,6DAA6D;AAC7D;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA,2CAA2C;AAC3C;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,oFAAoF;AACpF;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA,8DAA8D;AAC9D;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;AACtB;;AAEA,mGAAmG;AACnG;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA,8EAA8E;AAC9E;IACI,YAAY;IACZ,aAAa;AACjB","sourcesContent":["/* ====== Generic flex/height helpers ====== */\n.desc-col {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n.desc-fill {\n    flex: 1;\n    min-height: 0;\n}\n\n.desc-no-x {\n    overflow-x: hidden;\n}\n\n/* ====== Section headings ====== */\n.desc-label-row {\n    padding-left: 10px;\n}\n\n/* ====== Box wrapper (γκρι κάρτα) ====== */\n.desc-box {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    /* κόβει οριζόντιο */\n    padding: 10px;\n}\n\n/* ====== Inner white panel (textarea) ====== */\n.desc-panel {\n    flex: 1;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, .2);\n    overflow: hidden;\n}\n\n.desc-textarea {\n    display: block;\n    width: 100%;\n    height: 100%;\n    min-height: 0;\n    box-sizing: border-box;\n    resize: none;\n    border: none;\n    outline: none;\n    background: transparent;\n    overflow-wrap: anywhere;\n}\n\n/* ====== Lock notice ====== */\n.desc-lock {\n    padding: 8px 8px;\n    border-radius: 12px;\n    background: #E5E7EB;\n    border: 1px solid #bbb;\n    color: #374151;\n    display: flex;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, .15);\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 8px;\n    min-height: 60px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.desc-lock-title {\n    font-size: 12px;\n    font-weight: 700;\n    color: #111827;\n}\n\n/* ====== Buttons row (πάντα ίδια σειρά, responsive) ====== */\n.desc-buttons-row {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n}\n\n.desc-btn-col {\n    text-align: center;\n    flex: 1 1 0;\n    min-width: 140px;\n}\n\n.desc-btn-full {\n    width: 100%;\n}\n\n/* ====== Skills (read-only) panel ====== */\n.skills-wrapper {\n    height: 100%;\n    min-height: 0;\n}\n\n.skills-box {\n    position: relative;\n    height: 100%;\n    min-height: 0;\n    overflow: hidden;\n    padding: 10px;\n}\n\n.skills-scroll {\n    height: calc(100% - 48px);\n    /* αφήνει χώρο για το input */\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n/* Ρίζα: γεμίζει το διαθέσιμο ύψος και επιτρέπει στα παιδιά να κάνουν σωστό scroll */\n.desc-root {\n    height: 100%;\n    min-height: 0;\n}\n\n/* Το βασικό Col: να μπορεί να “σπάει” σωστά και να τεντώνει */\n.desc-col {\n    min-width: 0;\n    height: 100%;\n}\n\n/* Πάνω σειρά με το label */\n.desc-label-row {\n    padding-left: 10px;\n}\n\n/* Η σειρά που περιέχει το boxStyle: υπολογισμένο ύψος και μηδενικό min-height για σωστό overflow */\n.desc-content-row {\n    height: calc(100% - 28px);\n    min-height: 0;\n}\n\n/* Το Col που περιέχει το boxStyle: γεμίζει, δεν επιβάλλει δικό του overflow */\n.desc-content-col {\n    height: 100%;\n    min-height: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
